import { request } from "@/interface/helper";

const str = "marketingMember";

export const marketingMember = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/member/list" }),
    edit: (data) => request({ data, method: "post", url: "/member/modify" }),
  },
};
